<template>
   <div class="asset-menu-header">
      <div v-if="isSearch" class="header-text-wrapper">
         <span class="header-text uppercase">Search Results </span>
         <span class="header-text">for: </span>
         <span class="search-keywords">{{title}}</span>
      </div>

      <div v-else class="header-text-wrapper">
         <span class="header-text uppercase">{{title}}</span>
      </div>

      <div class="upload-icon" :class="{selected: uploadSelected}" v-if="upload" @click="$emit('uploadClicked'); uploadSelected = !uploadSelected;"></div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         uploadSelected: false
      }
   },

   props: {
      title: String,
      isSearch: Boolean,
      upload: Boolean
   }
}
</script>

<style lang="scss" scoped>
.asset-menu-header {
   font-size: 14px;
   padding-bottom: 10px;
   display: flex;
   justify-content: space-between;
   align-items: end;

   .header-text-wrapper {
      display: flex;
      align-items: baseline;
      white-space: pre;

      .search-keywords {
         overflow: hidden;
         white-space: nowrap;
         text-overflow: ellipsis;
         width: 120px;
         display: inline-block;
      }
   }

   
   .header-text {
      color: #f8c43f;

      &.uppercase {
         text-transform: uppercase;
      }
   }

   .search-keywords {
      color: white;
   }

   .upload-icon {
      width: 26px;
      height: 26px;
      cursor: pointer;
      margin-top: -4px;
      background-image: url(./../../assets/img/upload_icon.svg);

      &:hover,
      &.selected {
         background-image: url(./../../assets/img/upload_icon_selected.svg);
      }
   }
}
</style>
